module.exports = __webpack_public_path__ + "static/media/atomi-validator-logo.40b6978f.svg";